import api from "@lib/api/axios";
import { apiEnum } from "@shared/types/enums/apiEnum";

export type PayLoadTypeSaveMeetingType = {
    uid: string;
    resourcesIds: string;
    originalResourceIds?: string;
    meetingType: string;
    globalId?: string;
    isRecurring: number;
    isSendMail?: boolean;
    isNewMeeting: boolean;
    timeZoneName: string;
    organizerName: string;
    organizerEmail: string;
    subject?: string;
    startDate: string;
    endDate: string
};

export const saveMeetingType = async (payload: PayLoadTypeSaveMeetingType) => {
    const { data } = await api.post(apiEnum.saveMeetingType, payload);
    return data;
};